import PrimaryButton from "../../../../util/Btns/PrimaryButton";
import styles from "./Overview.module.scss";
import creativesPlaceholder from "../../../../Assets/applifecycle/creatives-placeholder.svg";
import appinfoPlaceholder from "../../../../Assets/applifecycle/appinfo-placeholder.svg";
import arrow from "../../../../Assets/applifecycle/walkthrough-arrow.svg";
import shabar from "../../../../Assets/applifecycle/walkthru-sha-bar.svg";
import store from "../../../../Assets/applifecycle/walkthru-shop.svg";
import upload from "../../../../Assets/applifecycle/walkthru-upload.svg";
import tick from "../../../../Assets/applifecycle/walkthru-tick.svg";
import deletebtn from "../../../../Assets/applifecycle/deleteicon.svg";
import { useHistory } from "react-router-dom";
import FingerprintModal from "../../../../components/consolecomponents/modal/FingerprintModal";
import { useState } from "react";
import IsLoading from "../../../../util/loader/IsLoading";
import { appStatus } from "../../../../util/helpers/statusHelper";
import { getStatus } from "../../../../util/helpers/funcHelper";
import { sliceString } from "../../../../util/helpers/funcHelper";
const Overview = ({ match, app, isLoading, isError }) => {
  const history = useHistory();
  const [addFingerprint, showAddFingerprint] = useState(false);
  const [pop, showPop] = useState(false);
  /**
   * Rendering after fetching
   */
  if (isLoading) {
    return <IsLoading />;
  }

  return (
    <>
      <FingerprintModal
        addFingerprint={addFingerprint}
        showAddFingerprint={showAddFingerprint}
      />
      <div className={styles.overviewcontainer}>
        <div className={styles.panel}>
          <div className={styles.info_manage_container}>
            <div className={styles.appinfo}>
              <h4>App Information</h4>
              <div className={styles.infobody}>
                <img
                  src={
                    app.builds?.[0]?.graphics?.appIcon?.url
                      ? app.builds?.[0]?.graphics?.appIcon?.url
                      : appinfoPlaceholder
                  }
                  alt="creatives images"
                />
                <div className="">
                  <h5>Application name</h5>
                  <span>{sliceString(0, 16, app.title, true)}</span>
                </div>
                {app?.activity !== "pwa" && app?.status != 0 && (
                  <div className="">
                    <h5>Size</h5>
                    <span>
                      {app.builds?.[0]?.activeRelease?.size
                        ? Math.ceil(app.builds?.[0]?.activeRelease?.size / 1024) + " MB"
                        : "-"}
                    </span>
                  </div>
                )}
                {app.builds?.[0]?.activeRelease?.status && (
                  <div className="">
                    <h5>Submission Status</h5>
                    <>
                      {getStatus(
                        app.builds?.[0]?.activeRelease?.status,
                        appStatus?.release
                      )}
                    </>
                  </div>
                )}

                <div className="">
                  <h5>Category</h5>
                  {app.category && app.category.name ? (
                    <span
                      className={styles.category}
                      style={{
                        backgroundColor:
                          app.category.name === "gaming"
                            ? "#db6a18"
                            : app.category.name === "entertainment"
                            ? "#179cad"
                            : app.category.name === "learning"
                            ? "#4096ef"
                            : app.category.name === "health&wellness"
                            ? "#276fd1"
                            : app.category.name === "shopping"
                            ? "#b538db"
                            : app.category.name === "productivity"
                            ? "#7758de"
                            : "#707070",
                      }}
                    >
                      {app.category.name}
                    </span>
                  ) : null}
                </div>
                <div className="">
                  <h5>Created</h5>
                  <span>{app.created_at}</span>
                </div>
                <div className="test">
                  <h5>Publish Status</h5>
                  <span>{getStatus(app?.status, appStatus.app)}</span>
                </div>
                {app.builds?.[0]?.activeRelease?.version && app?.status != 0 && (
                  <div className="">
                    <h5>Current Version</h5>
                    <span>{app.builds?.[0]?.activeRelease?.version}</span>
                  </div>
                )}
                {app?.ageRating && (
                  <div className="">
                    <h5>Age Criteria</h5>
                    <span>{app.ageRating + " Years and above "}</span>
                  </div>
                )}
              </div>
            </div>
            <PrimaryButton
              onClick={() => history.push(`${match.url}/store-listing`)}
            >
              Manage
            </PrimaryButton>
          </div>
          <div className={styles.creatives_container}>
            <h4>Creatives</h4>
            <div className={styles.creatives_body}>
              <img
                src={
                  app.builds?.[0]?.graphics?.bannerSmall?.url
                    ? app.builds?.[0]?.graphics?.bannerSmall?.url
                    : creativesPlaceholder
                }
                alt="creatives images"
              />
              <img
                src={
                  app.builds?.[0]?.graphics?.screenshots?.[0]?.url
                    ? app.builds?.[0]?.graphics?.screenshots?.[0]?.url
                    : creativesPlaceholder
                }
                alt="creatives images"
              />
              <img
                src={
                  app.builds?.[0]?.graphics?.screenshots?.[1]?.url
                    ? app.builds?.[0]?.graphics?.screenshots?.[1]?.url
                    : creativesPlaceholder
                }
                alt="creatives images"
              />
              <img
                src={
                  app.builds?.[0]?.graphics?.screenshots?.[2]?.url
                    ? app.builds?.[0]?.graphics?.screenshots?.[2]?.url
                    : creativesPlaceholder
                }
                alt="creatives images"
              />
              <img
                src={
                  app.builds?.[0]?.graphics?.screenshots?.[3]?.url
                    ? app.builds?.[0]?.graphics?.screenshots?.[3]?.url
                    : creativesPlaceholder
                }
                alt="creatives images"
              />
              <img
                src={
                  app.builds?.[0]?.graphics?.screenshots?.[4]?.url
                    ? app.builds?.[0]?.graphics?.screenshots?.[4]?.url
                    : creativesPlaceholder
                }
                alt="creatives images"
              />
            </div>
          </div>
        </div>
        <div className={`${styles.SHAcertificate} d-hide`}>
          <div className={styles.shaheader}>
            <h4>Add SHA Certificate Fingerprint</h4>
            <PrimaryButton onClick={() => showAddFingerprint(true)}>
              Add Fingerprint
            </PrimaryButton>
          </div>
          <div className={styles.shabody}>
            <div className={styles.shacategories}>
              <span></span>
              <span>#</span>
              <span>SHA Certificate Fingerprints</span>
              <span>Type</span>
              <span></span>
            </div>
            <div className={styles.shaitem}>
              <span></span>
              <span>1</span>
              <span>
                d1:e6:96:b8:d3:f4:1f:62:ce:72:ae:da:6e:c1:70:x0:1d:7a:8e:40
              </span>
              <span>Production/Debug</span>
              <span>
                <img
                  src={deletebtn}
                  style={{ height: "2em", cursor: "pointer" }}
                  alt="delete button"
                />
              </span>
            </div>
          </div>
        </div>
        <div
          onMouseEnter={() => showPop(true)}
          className={`${styles.walkthrough} d-hide`}
        >
          <h4 className={styles.walkthroughitem}>
            <span className={styles.stepcount}>1</span>{" "}
            <span>Create SHA Fingerprint</span>
          </h4>
          <img src={arrow} alt="arrow" />
          <h4 className={styles.walkthroughitem}>
            <span className={styles.stepcount}>2</span>{" "}
            <span>Create Store Listing</span>
          </h4>
          <img src={arrow} alt="arrow" />
          <h4 className={styles.walkthroughitem}>
            <span className={styles.stepcount}>3</span>{" "}
            <span>Upload Build</span>
          </h4>
          <img src={arrow} alt="arrow" />
          <h4 className={styles.walkthroughitem}>
            <span className={styles.stepcount}>4</span> <span>Publish</span>
          </h4>
        </div>
        <div
          onMouseLeave={() => showPop(false)}
          style={{ display: `${pop ? "flex" : "none"}` }}
          className={styles.walkthroughpop}
        >
          <div className={styles.walkthroughpopitem}>
            <span className={styles.stepcnt}>Step 1</span>
            <img src={shabar} alt="steps" /> <h4>Create SHA Fingerprint</h4>
            <span>
              Click here to set upa SHA certificate fingerprint process
            </span>
          </div>
          <img src={arrow} alt="arrow" />
          <div className={styles.walkthroughpopitem}>
            <span className={styles.stepcnt}>Step 2</span>
            <img src={store} alt="steps" /> <h4>Create Store Listing</h4>
            <span>
              Fill in all the details & upload all the assetsto better showcase
              your app
            </span>
          </div>
          <img src={arrow} alt="arrow" />
          <div className={styles.walkthroughpopitem}>
            <span className={styles.stepcnt}>Step 3</span>
            <img src={upload} alt="steps" /> <h4>Upload Build</h4>
            <span>
              Upload your builds and make sure to use the current build name
            </span>
          </div>
          <img src={arrow} alt="arrow" />
          <div className={styles.walkthroughpopitem}>
            <span className={styles.stepcnt}>Step 4</span>
            <img src={tick} alt="steps" /> <h4>Publish</h4>
            <span>
              After publishing upon successful review your app gets listed on
              app store
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Overview;
